import { render, staticRenderFns } from "./IconContainer.vue?vue&type=template&id=78c80aa2&"
import script from "./IconContainer.vue?vue&type=script&lang=js&"
export * from "./IconContainer.vue?vue&type=script&lang=js&"
import style0 from "./IconContainer.vue?vue&type=style&index=0&id=78c80aa2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports